import type { WorkoutPlanInfo } from '@az3fr/core';
import { createID, workoutPlanStatuses, workoutVisibilities } from '@az3fr/core';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

function createNewWorkoutPlan(payload: Partial<WorkoutPlanInfo>): WorkoutPlanInfo {
	const now = new Date().toISOString();
	return {
		id: createID('workoutPlan'),
		status: workoutPlanStatuses.DRAFT,
		canonicalName: null,
		// @todo: this is a placeholder name, we should change it to a proper name later
		name: 'NO_NAME',
		description: null,
		system: false,
		userId: null,
		visibility: workoutVisibilities.PUBLIC,
		estimatedDurationSeconds: null,
		notes: null,
		updatedAt: now,
		...payload,
	};
}

const workoutPlanAdapter = createEntityAdapter<WorkoutPlanInfo>();

const workoutPlanSlice = createSlice({
	name: 'entities/workoutPlan',
	initialState: workoutPlanAdapter.getInitialState(),
	reducers: {
		addedOne: (state, action: PayloadAction<Partial<WorkoutPlanInfo>>) =>
			workoutPlanAdapter.addOne(state, createNewWorkoutPlan(action.payload)),

		updatedOne: workoutPlanAdapter.updateOne,
		removedOne: workoutPlanAdapter.removeOne,
	},
});
type WorkoutPlanSliceState = ReturnType<typeof workoutPlanAdapter.getInitialState>;

const workoutPlanSliceActions = { ...workoutPlanSlice.actions };
const workoutPlanSliceReducer = workoutPlanSlice.reducer;

export { workoutPlanSliceActions, workoutPlanSliceReducer, workoutPlanAdapter };
export type { WorkoutPlanSliceState };
